import { EyeIcon, RefreshIcon } from '@heroicons/react/solid';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Dropdown from '../../components/Dropdown';
import useTopicsAdmin from '../../hooks/useTopicsAdmin';
import { useUser } from '../../hooks/useUser';
import useUsers from '../../hooks/useUsers';
import useBranches from '../../hooks/usebranches';
import { Topic } from '../../redux/types/topics';

const UserList = () => {
  const topicQuery = useTopicsAdmin();
  const usersQuery = useUsers();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [updating, setUpdating] = useState(false);
  const branchesQuery = useBranches();
  const userQuery = useUser();
  const [selectedBranch, setSelectedBranch] = useState('');

  const columns: GridColDef[] = useMemo(() => {
    return [
      {
        field: 'title',
        headerName: 'Titel',
        flex: 2,
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
      {
        field: 'posts',
        headerName: 'Berichten',
        flex: 1,
        valueGetter: (params: any) => {
          return params.row?.posts.length;
        },
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
      {
        field: 'members',
        headerName: 'Leden',
        flex: 1,
        valueGetter: (params: any) => {
          return params.row?.members.length;
        },
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
      {
        field: 'createdAt',
        headerName: 'Aangemaakt',
        flex: 1.2,
        valueGetter: (params: any) => {
          return params.row?.createdAt.slice(0, 10);
        },
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
      {
        field: 'isPrivate',
        headerName: 'Privé',
        flex: 1,
        valueGetter: (params: any) => {
          return params.row?.isPrivate ? 'Ja' : 'Nee';
        },
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
      {
        field: 'branch',
        headerName: 'Vestiging',
        flex: 1,
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
      {
        field: 'action',
        headerName: 'Details',
        flex: 1,
        renderCell: (params) => {
          return (
            <button
              className="p-2"
              onClick={() => {
                navigate(`/topics/${params.row?._id}`);
              }}
            >
              <EyeIcon className="w-5 text-gray-500" />
            </button>
          );
        },
        headerClassName: 'bg-gray-100 text-grey-dark font-bold',
      },
    ];
  }, []);

  useEffect(() => {
    if (selectedBranch.length) return;
    if (!userQuery.isSuccess) return;

    setSelectedBranch(userQuery.data.branch);
  }, [branchesQuery, userQuery]);

  if (!topicQuery.isSuccess) return null;
  if (!usersQuery.isSuccess) return null;
  if (!branchesQuery.isSuccess) return null;
  if (!userQuery.isSuccess) return null;

  let branchOptions: Array<any> = [userQuery.data.branch];
  if (userQuery.data.role === 'SUPER_ADMIN') {
    branchOptions = branchesQuery.data.map((branch: any) => branch.name);
  }

  return (
    <section className="flex-col space-y-3">
      <div className="flex justify-between">
        <div className="w-64">
          <Dropdown
            disabled={userQuery.data.role !== 'SUPER_ADMIN'}
            options={branchOptions}
            placeholder={userQuery.data.branch}
            onSelect={(value: string) => setSelectedBranch(value)}
            value={`Vestiging: ${selectedBranch}`}
          />
        </div>
      </div>
      <DataGrid
        autoHeight
        rows={topicQuery.data.filter(
          (topic: Topic) => topic.branch === selectedBranch
        )}
        columns={columns}
        getRowId={(row) => row._id}
        className="bg-white"
      />
    </section>
  );
};

export default UserList;
